import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { Select } from 'components/fields'
import { apiCommon } from 'helpers/decorators/api'

@apiCommon()
class FilterByCountry extends Component {
  static propTypes = {
    ics: PropTypes.bool,
    multi: PropTypes.bool,
    common: PropTypes.object,
    fetchCountriesWithStructure: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string,
    intlKey: PropTypes.string
  }

  static defaultProps = {
    label: 'Country',
    intlKey: 'label.country',
    name: 'country_id'
  }

  handleOpen = () => {
    const { common, ics } = this.props

    if (!common.countries.loaded && !ics) {
      this.props.fetchCountriesWithStructure()
    }

    if (!common.ics.loaded && ics) {
      this.props.fetchCountriesWithStructure()
    }
  }

  render() {
    const { common, label, name, intlKey, ics, multi } = this.props
    const list = ics ? common.ics.list : common.countries.list
    const loading = common.countries.loading

    return (
      <Select
        label={label}
        intlKey={intlKey}
        name={name}
        options={list}
        searchable
        loading={loading}
        onOpen={this.handleOpen}
        isDeffered
        multi={multi}
      />
    )
  }
}

export default FilterByCountry
